import React from 'react';
import { Platform, StyleSheet } from 'react-native';

import { useColors, useLessonContext } from '../../../hooks';
import type { UseSound } from '../../../hooks/use-sound';
import { AudioPlayer } from '../../audio-player/audio-player';
import { TranslatableText } from '../../translatable-text/translatable-text';
import { smallPaddingBox } from '../../view-style';
import { KaraokeText } from '../karaoke-text/karaoke-text';

interface KaraokeAudioPlayerProps {
  text: string;
  textAudioParts?;
  textTranslation?;
  onReproduce?: () => void;
  sound: UseSound;
}
const fontSize = Platform.OS === 'web' ? 'extraSmall' : 'small';

const KaraokeAudioPlayer: React.FC<KaraokeAudioPlayerProps> = ({
  text,
  textAudioParts,
  textTranslation,
  onReproduce,
  sound,
}) => {
  const colors = useColors();
  const { translationActive } = useLessonContext();

  return (
    <>
      <AudioPlayer
        sound={sound}
        barContainerColor={colors.grayLight}
        activeColor={colors.primary}
        inactiveColor={colors.grayDark}
        containerStyle={{ ...smallPaddingBox }}
        onReproduce={onReproduce}
      />
      <TranslatableText
        containerStyle={styles.card}
        textStyle={styles.textStyle}
        isHtml={!textAudioParts && true}
        isMarkdown={textAudioParts && false}
        fontSize={fontSize}
        translation={
          translationActive && textTranslation ? (
            !textAudioParts ? (
              text
            ) : (
              <KaraokeText
                fontSize={fontSize}
                texts={textAudioParts.map((t) => t.text)}
                textDurations={textAudioParts.map((t) => t.seconds)}
              />
            )
          ) : (
            textTranslation
          )
        }
      >
        {translationActive && textTranslation ? (
          textTranslation
        ) : !textAudioParts ? (
          text
        ) : (
          <KaraokeText
            fontSize={fontSize}
            texts={textAudioParts.map((t) => t.text)}
            textDurations={textAudioParts.map((t) => t.seconds)}
          />
        )}
      </TranslatableText>
    </>
  );
};

export default KaraokeAudioPlayer;

const styles = StyleSheet.create({
  card: {
    width: '100%',
  },
  textStyle: {
    marginTop: 0,
    marginBottom: 0,
  },
});
